import React from 'react';
import { Helmet } from 'react-helmet';


const hotelSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Hotel',
      '@id': 'https://www.michelbergerhotel.com/#hotel',
      name: 'Michelberger Hotel',
      url: 'https://www.michelbergerhotel.com',
      description: 'Independent boutique hotel in Berlin-Friedrichshain with uniquely designed rooms, farm-to-table restaurant, wine bar, and creative event spaces.',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Warschauer Straße 39-40',
        addressLocality: 'Berlin',
        addressRegion: 'Berlin',
        postalCode: '10243',
        addressCountry: 'DE',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 52.5045667,
        longitude: 13.4478541,
      },
      telephone: '+49-30-29778590',
      email: 'reservations@michelbergerhotel.com',
      priceRange: '$$',
      numberOfRooms: 119,
      amenityFeature: [
        { '@type': 'LocationFeatureSpecification', name: 'Free Wi-Fi', value: true },
        { '@type': 'LocationFeatureSpecification', name: 'Restaurant', value: true },
        { '@type': 'LocationFeatureSpecification', name: 'Wine Bar', value: true },
        { '@type': 'LocationFeatureSpecification', name: 'Event Spaces', value: true },
        { '@type': 'LocationFeatureSpecification', name: 'Sauna', value: true },
        { '@type': 'LocationFeatureSpecification', name: 'Cinema', value: true },
      ],
      award: [
        "A Hotel Life's Best Hotels of the Year",
        'MICHELIN Guide Listed Hotel',
        'Lonely Planet Top Choice',
      ],
      sameAs: [
        'https://www.instagram.com/michelbergerhotel/',
        'https://www.instagram.com/michelbergerrestaurant/',
        'https://www.instagram.com/michelbergerfarm/',
      ],
    },
    {
      '@type': 'Organization',
      '@id': 'https://www.michelbergerhotel.com/#organization',
      name: 'Michelberger Hotel',
      url: 'https://www.michelbergerhotel.com',
      contactPoint: [
        {
          '@type': 'ContactPoint',
          telephone: '+49-30-29778590',
          contactType: 'reservations',
          email: 'reservations@michelbergerhotel.com',
          availableLanguage: ['English', 'German'],
        },
      ],
    },
    {
      '@type': 'WebSite',
      '@id': 'https://www.michelbergerhotel.com/#website',
      name: 'Michelberger Hotel',
      url: 'https://www.michelbergerhotel.com',
      inLanguage: ['en', 'de'],
    },
  ],
};

const SchemaOrg = () => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify(hotelSchema)}
    </script>
  </Helmet>
);

export default SchemaOrg;
